/*
 * Copyright (c) 2020. Sanish Manandhar
 * All Rights Reserved
 */

import {
  COMPANY_CLEAN_REQUEST,
  COMPANY_FETCH_REQUEST,
  COMPANY_FETCH_REQUEST_SUCCESS,
  COMPANY_FETCH_REQUEST_FAILURE,
  COMPANY_UPSERT_REQUEST,
  COMPANY_UPSERT_REQUEST_SUCCESS,
  COMPANY_UPSERT_REQUEST_FAILURE,
  COMPANY_EMAIL_PROCESS,
  COMPANY_EMAIL_PROCESS_SUCCESS,
  COMPANY_EMAIL_PROCESS_FAILURE,
  COMPANY_REGISTRATION_SECRET_REQUEST,
  COMPANY_REGISTRATION_SECRET_REQUEST_SUCCESS,
  COMPANY_REGISTRATION_SECRET_REQUEST_FAILURE,
  COMPANY_REGISTRATION_REQUEST,
  COMPANY_REGISTRATION_REQUEST_SUCCESS,
  COMPANY_REGISTRATION_REQUEST_FAILURE,
  COMPANY_REGISTRATION_COMPLETE_REQUEST,
  COMPANY_REGISTRATION_COMPLETE_REQUEST_SUCCESS,
  COMPANY_REGISTRATION_COMPLETE_REQUEST_FAILURE,
  COMPANY_STRIPE_KEY_VALIDATION_REQUEST,
  COMPANY_STRIPE_KEY_VALIDATION_REQUEST_SUCCESS,
  COMPANY_STRIPE_KEY_VALIDATION_REQUEST_FAILURE,
  COMPANY_SECRET_CLEAN_REQUEST,
  QUICKBOOK_SIGNUP_UPDATE_REQUEST,
  QUICKBOOK_SIGNUP_UPDATE_REQUEST_SUCCESS,
  QUICKBOOK_SIGNUP_UPDATE_REQUEST_FAILURE,
  QUICKBOOK_SIGNIN_UPDATE_REQUEST,
  QUICKBOOK_SIGNIN_UPDATE_REQUEST_SUCCESS,
  QUICKBOOK_SIGNIN_UPDATE_REQUEST_FAILURE,
  QUICKBOOK_LOGIN_STATUS_FETCH_REQUEST,
  QUICKBOOK_LOGIN_STATUS_FETCH_REQUEST_SUCCESS,
  QUICKBOOK_LOGIN_STATUS_FETCH_REQUEST_FAILURE,
  COMPANY_DROPDOWN_FETCH_REQUEST,
  COMPANY_DROPDOWN_FETCH_REQUEST_SUCCESS,
  COMPANY_DROPDOWN_FETCH_REQUEST_FAILURE,
  FETCH_ONBOARDING_COMPANIES_REQUEST,
  FETCH_ONBOARDING_COMPANIES_REQUEST_SUCCESS,
  FETCH_ONBOARDING_COMPANIES_REQUEST_FAILURE,
  DELETE_ONBOARDING_COMPANY_REQUEST,
  DELETE_ONBOARDING_COMPANY_REQUEST_SUCCESS,
  DELETE_ONBOARDING_COMPANY_REQUEST_FAILURE,
  UPDATE_ONBOARDING_COMPANY_REQUEST,
  UPDATE_ONBOARDING_COMPANY_REQUEST_SUCCESS,
  UPDATE_ONBOARDING_COMPANY_REQUEST_FAILURE,
  ONBOARDING_COMPANY_DETAIL_FETCH_REQUEST,
  ONBOARDING_COMPANY_DETAIL_FETCH_REQUEST_SUCCESS,
  ONBOARDING_COMPANY_DETAIL_FETCH_REQUEST_FAILURE,
  REFERRAL_REGISTRATION_REQUEST,
  REFERRAL_REGISTRATION_REQUEST_SUCCESS,
  REFERRAL_REGISTRATION_REQUEST_FAILURE,
  REFERRAL_CLEAN_REQUEST,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  emailProcessPayload: [],
  emailProcessLoading: false,
  emailProcessErrors: {},
  secretPayload: [],
  secretLoading: false,
  secretErrors: {},
  registerationPayload: [],
  registerationLoading: false,
  registerationErrors: {},
  registerationCompletePayload: [],
  registerationCompleteLoading: false,
  registerationCompleteErrors: {},
  stripeKeyValidationLoading: false,
  stripeKeyValidation: [],
  stripeKeyValidationErrors: {},
  quickbookPayload: [],
  quickbookLoading: false,
  quickbookErrors: {},
  quickbookLoginPayload: [],
  quickbookLoginLoading: false,
  quickbookLoginErrors: {},
  quickbookSignInPayload: [],
  quickbookSignInLoading: false,
  quickbookSignInErrors: {},
  companyDropdown: [],
  companyDropdownLoading: false,
  companyDropdownErrors: {},
  onBoardingCompanies: [],
  onBoardingCompaniesLoading: false,
  onBoardingCompaniesErrors: {},
  onBoardingCompaniesPagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  deleteOnBoardingCompany: [],
  deleteOnBoardingCompanyLoading: false,
  deleteOnBoardingCompanyErrors: {},
  updateOnBoardingCompany: [],
  updateOnBoardingCompanyLoading: false,
  updateOnBoardingCompanyErrors: {},
  onBoardingCompany: [],
  onBoardingCompanyLoading: false,
  onBoardingCompanyErrors: {},
  referralRegistrationLoading: false,
  referralRegistrationErrors: {},
  referralRegistrationPayload: [],
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const companyReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case COMPANY_FETCH_REQUEST:
    case COMPANY_UPSERT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case COMPANY_FETCH_REQUEST_SUCCESS:
    case COMPANY_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case COMPANY_FETCH_REQUEST_FAILURE:
    case COMPANY_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case COMPANY_EMAIL_PROCESS:
      return Object.assign({}, state, {
        emailProcessLoading: true,
      });

    case COMPANY_EMAIL_PROCESS_SUCCESS:
      return Object.assign({}, state, {
        emailProcessLoading: false,
        emailProcessPayload: action.data,
        emailProcessErrors: {},
      });

    case COMPANY_EMAIL_PROCESS_FAILURE:
      return Object.assign({}, state, {
        emailProcessLoading: false,
        emailProcessErrors: action.error,
      });

    case COMPANY_REGISTRATION_SECRET_REQUEST:
      return Object.assign({}, state, {
        secretLoading: true,
      });

    case COMPANY_REGISTRATION_SECRET_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        secretLoading: false,
        secretPayload: action.data,
        secretErrors: {},
      });

    case COMPANY_REGISTRATION_SECRET_REQUEST_FAILURE:
      return Object.assign({}, state, {
        secretLoading: false,
        secretErrors: action.error,
      });

    case COMPANY_REGISTRATION_REQUEST:
      return Object.assign({}, state, {
        registerationLoading: true,
      });

    case COMPANY_REGISTRATION_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        registerationLoading: false,
        registerationPayload: action.data,
        registerationErrors: {},
      });

    case COMPANY_REGISTRATION_REQUEST_FAILURE:
      return Object.assign({}, state, {
        registerationLoading: false,
        registerationErrors: action.error,
      });

    case COMPANY_REGISTRATION_COMPLETE_REQUEST:
      return Object.assign({}, state, {
        registerationCompleteLoading: true,
      });

    case COMPANY_REGISTRATION_COMPLETE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        registerationCompleteLoading: false,
        registerationCompletePayload: action.data,
        registerationCompleteErrors: {},
      });

    case COMPANY_REGISTRATION_COMPLETE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        registerationCompleteLoading: false,
        registerationCompleteErrors: action.error,
      });

    case COMPANY_STRIPE_KEY_VALIDATION_REQUEST:
      return Object.assign({}, state, {
        stripeKeyValidationLoading: true,
      });

    case COMPANY_STRIPE_KEY_VALIDATION_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        stripeKeyValidationLoading: false,
        stripeKeyValidation: action.data,
        stripeKeyValidationErrors: {},
      });

    case COMPANY_STRIPE_KEY_VALIDATION_REQUEST_FAILURE:
      return Object.assign({}, state, {
        stripeKeyValidationLoading: false,
        stripeKeyValidationErrors: action.error,
      });

    case COMPANY_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
        emailProcessPayload: [],
        emailProcessLoading: false,
        emailProcessErrors: {},
        secretPayload: [],
        secretLoading: false,
        secretErrors: {},
        registerationPayload: [],
        registerationLoading: false,
        registerationErrors: {},
        registerationCompletePayload: [],
        registerationCompleteLoading: false,
        registerationCompleteErrors: {},
      });

    case COMPANY_SECRET_CLEAN_REQUEST:
      return Object.assign({}, state, {
        secretPayload: [],
        secretLoading: false,
        secretErrors: {},
        stripeKeyValidationLoading: false,
        stripeKeyValidation: [],
        stripeKeyValidationErrors: {},
      });

    case QUICKBOOK_SIGNUP_UPDATE_REQUEST:
      return Object.assign({}, state, {
        quickbookLoading: true,
      });

    case QUICKBOOK_SIGNUP_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        quickbookLoading: false,
        quickbookPayload: action.data,
        quickbookErrors: {},
      });

    case QUICKBOOK_SIGNUP_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        quickbookLoading: false,
        quickbookErrors: action.error,
      });

    case QUICKBOOK_LOGIN_STATUS_FETCH_REQUEST:
      return Object.assign({}, state, {
        quickbookLoginLoading: true,
      });

    case QUICKBOOK_LOGIN_STATUS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        quickbookLoginLoading: false,
        quickbookLoginPayload: action.data,
        quickbookLoginErrors: {},
      });

    case QUICKBOOK_LOGIN_STATUS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        quickbookLoginLoading: false,
        quickbookLoginErrors: action.error,
      });

    case QUICKBOOK_SIGNIN_UPDATE_REQUEST:
      return Object.assign({}, state, {
        quickbookSignInLoading: true,
      });

    case QUICKBOOK_SIGNIN_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        quickbookSignInLoading: false,
        quickbookSignInPayload: action.data,
        quickbookSignInErrors: {},
      });

    case QUICKBOOK_SIGNIN_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        quickbookSignInLoading: false,
        quickbookSignInErrors: action.error,
      });

    case COMPANY_DROPDOWN_FETCH_REQUEST:
      return Object.assign({}, state, {
        companyDropdownLoading: true,
      });

    case COMPANY_DROPDOWN_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        companyDropdownLoading: false,
        companyDropdown: action.data,
        companyDropdownErrors: {},
      });

    case COMPANY_DROPDOWN_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        companyDropdownLoading: false,
        companyDropdownErrors: action.error,
      });

    case FETCH_ONBOARDING_COMPANIES_REQUEST:
      return Object.assign({}, state, {
        onBoardingCompaniesLoading: true,
      });

    case FETCH_ONBOARDING_COMPANIES_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        onBoardingCompaniesLoading: false,
        onBoardingCompanies: action.data,
        onBoardingCompaniesErrors: {},
        onBoardingCompaniesPagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case FETCH_ONBOARDING_COMPANIES_REQUEST_FAILURE:
      return Object.assign({}, state, {
        onBoardingCompaniesLoading: false,
        onBoardingCompaniesErrors: action.error,
      });

    case DELETE_ONBOARDING_COMPANY_REQUEST:
      return Object.assign({}, state, {
        deleteOnBoardingCompanyLoading: true,
      });

    case DELETE_ONBOARDING_COMPANY_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        deleteOnBoardingCompanyLoading: false,
        deleteOnBoardingCompany: action.data,
        deleteOnBoardingCompanyErrors: {},
      });

    case DELETE_ONBOARDING_COMPANY_REQUEST_FAILURE:
      return Object.assign({}, state, {
        deleteOnBoardingCompanyLoading: false,
        deleteOnBoardingCompanyErrors: action.error,
      });

    case UPDATE_ONBOARDING_COMPANY_REQUEST:
      return Object.assign({}, state, {
        updateOnBoardingCompanyLoading: true,
      });

    case UPDATE_ONBOARDING_COMPANY_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        updateOnBoardingCompanyLoading: false,
        updateOnBoardingCompany: action.data,
        updateOnBoardingCompanyErrors: {},
      });

    case UPDATE_ONBOARDING_COMPANY_REQUEST_FAILURE:
      return Object.assign({}, state, {
        updateOnBoardingCompanyLoading: false,
        updateOnBoardingCompanyErrors: action.error,
      });

    case ONBOARDING_COMPANY_DETAIL_FETCH_REQUEST:
      return Object.assign({}, state, {
        onBoardingCompanyLoading: true,
      });

    case ONBOARDING_COMPANY_DETAIL_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        onBoardingCompanyLoading: false,
        onBoardingCompany: action.data,
        onBoardingCompanyErrors: {},
      });

    case ONBOARDING_COMPANY_DETAIL_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        onBoardingCompanyLoading: false,
        onBoardingCompanyErrors: action.error,
      });
    case REFERRAL_REGISTRATION_REQUEST:
      return Object.assign({}, state, {
        referralRegistrationLoading: true,
      });
    case REFERRAL_REGISTRATION_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        referralRegistrationLoading: false,
        referralRegistrationPayload: action.data,
      });
    case REFERRAL_REGISTRATION_REQUEST_FAILURE:
      return Object.assign({}, state, {
        referralRegistrationLoading: false,
        referralRegistrationErrors: action.error,
      });
    case REFERRAL_CLEAN_REQUEST:
      return Object.assign({}, state, {
        referralRegistrationLoading: false,
        referralRegistrationPayload: [],
        referralRegistrationErrors: {},
      });

    default:
      return state;
  }
};

export default companyReducer;
